module.exports = __webpack_public_path__ + "static/media/twitter.affc6e0b.svg";